import { AxiosError, AxiosPromise } from 'axios';
import { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

type getApiDataProps = {
  api: (body?: object & FormData & any) => AxiosPromise<any>;
  params?: object & FormData & any;
  isSkip?: boolean;
};

const useGetApiData = ({ api, params, isSkip }: getApiDataProps) => {
  const history = useHistory();
  const [data, setData] = useState<any>();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [rawError, setRawError] = useState<Record<string, any> | null>(null);

  const handleRequest = useCallback(
    async body => {
      setError('');
      try {
        setIsLoading(true);

        if (typeof body === 'object') {
          Object.keys(body).forEach(
            key =>
              (body[key] === undefined ||
                body[key] === null ||
                body[key] === '') &&
              delete body[key],
          );
          delete body.toggle;
        }

        const { data } = await api(body);
        setData(data);
        return data;
      } catch (error: AxiosError | any) {
        const code =
          error?.response?.data?.code || error?.code || error?.status;
        const message =
          error?.response?.data?.message || error?.message || error?.detail;
        if ((code === 400 && !isSkip) || code === 403) {
          history.push('/page-not-found');
        }
        setError(message);
        setRawError(error);
        return { code, message, error: true };
      } finally {
        setIsLoading(false);
      }
    },
    [api, history, isSkip],
  );

  useEffect(() => {
    if (isSkip) return;
    handleRequest(params);
  }, [handleRequest, params, isSkip]);

  return { data, isLoading, handleRequest, error, setData, rawError };
};

export default useGetApiData;
